module.exports = __webpack_public_path__ + "static/underConstruction-3f5791bc407deae16728ff7acc7987a0.jpg";